import type { PaymentOut } from '@myrentalmate/api-client';

export const METHOD_LABELS: Record<PaymentOut['method'], string> = {
  check: 'Check',
  cash: 'Cash',
  zelle: 'Zelle',
  money_order: 'Money order',
  card: 'Card',
  ach: 'Bank account',
};

/** Stripe records these by itself when the money arrives. */
export const isOnlineMethod = (method: PaymentOut['method']) =>
  method === 'card' || method === 'ach';

export const METHOD_OPTIONS = (Object.keys(METHOD_LABELS) as PaymentOut['method'][])
  .filter((method) => !isOnlineMethod(method))
  .map((value) => ({ value, label: METHOD_LABELS[value] }));

export const KIND_LABELS: Record<PaymentOut['kind'], string> = {
  rent: 'Rent',
  deposit: 'Deposit',
};
